/**
 * Small navigation helpers shared by the map surfaces, so "zoom to this site"
 * eases the same way whether it was triggered from the legend, a card, or a
 * search result.
 */

import type maplibregl from 'maplibre-gl'
import { SITE_ZOOM } from '../config/mapConfig'

export interface SitePosition {
	latitude?: number | null
	longitude?: number | null
}

/** True when the site has coordinates the map can actually be flown to. */
export function hasPosition(site: SitePosition | null | undefined): boolean {
	if (!site) return false
	const { latitude, longitude } = site
	return (
		typeof latitude === 'number' &&
		typeof longitude === 'number' &&
		Number.isFinite(latitude) &&
		Number.isFinite(longitude)
	)
}

/**
 * Ease the map to a site. A no-op when the map has not loaded yet or the site
 * has no coordinates, so callers do not have to guard.
 */
export function flyToSite(
	map: maplibregl.Map | null | undefined,
	site: SitePosition | null | undefined,
	zoom: number = SITE_ZOOM,
): void {
	if (!map || !hasPosition(site)) return
	map.flyTo({
		center: [site!.longitude as number, site!.latitude as number],
		zoom,
		duration: 800,
		essential: true,
	})
}
